
import React, { useState, useEffect } from 'react'
import Footer from './Footer'
import Highlights from './Highlights'
import Header from './Header'
import Loginmobile from './Loginmobile'
import Carousel from './Carousel'
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify'
import Account from './Account'
import { Newfullmarket } from './Newfullmarket'
import ANnouncement from './ANnouncement'
import Navcasino from '../mobilecomponent/Navcasino/Navcasino'
import Multimarket from "./Multimarket"
import InPlay from "./MobileInplay"
import FancyRules from './FancyRules'
import FooterPolicy from './policylink/FooterPolicy'
import FooterGtc from './policylink/FooterGtc'
import FooterRnr from './policylink/FooterRnr'
import Footerkyc from './policylink/FooterKyc'
import FooterResGaming from './policylink/FooterResGaming'
import FooterAboutus from './policylink/FooterAboutus'
import FooterSepolicy from './policylink/FooterSepolicy'
import FooterUpolicy from './policylink/FooterUpolicy'
import Home from './Home'
import WinnerMarket from './WinnerMarket'
import LoadingOverlay from "./components/loading-overlay/loading-overlay";
import {useGlobalLoading} from "../serives/state/states";

import Deposit from "./deposit";
import Withdraw from "./withdraw";
import RegisterMobile from "./register-mobile";
import queryString from "query-string";
import {Link} from "react-router-dom";
import TopHeader from "./top-header";
import DwHistory from "./dw-history";
import {useMutation} from "@tanstack/react-query";
import {refreshBalanceApiRq} from "../serives/react-query/api-actions";
import {queryClient} from "../serives/react-query/provider";
import {RQ_KEY} from "../serives/react-query/constant";
import {getRqData} from "../serives/react-query/rq-helper";

import moneyIcon from "../images/money-icon.svg";
import { Topbanner } from './Topbanner'

const cookies = new Cookies();
window.flag = 0;
var tt;
toast.configure()

export default function Combine(props) {
  const [globalLoading] = useGlobalLoading();
  var eventId = null;
  var marketId = null;
  var eventT = 3;
  if (props.match.params.eventT === '4' || props.match.params.eventT === '1' || props.match.params.eventT === '2' || props.match.params.eventT === '7522' || props.match.params.eventT === '2378962' || props.match.params.eventT === '138') {
    eventId = props.match.params.eventId;
    marketId = props.match.params.marketId;
    eventT = 0;
  }
  if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'sports') {
    eventT = 1;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'inplay') {
    eventT = 2;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'home') {
    eventT = 3;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'multimarket') {
    eventT = 4;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'myaccount') {
    eventT = 5;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'WinnerMarket') {
    eventT = 9;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'Fairhorsefullmarket') {
    eventT = 10;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'CasinoList') {
    eventT = 11;
  }  else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'deposit') {
    eventT = 12;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'withdraw') {
    eventT = 13;
  } else if (props.match.params.eventType === 'd' && props.match.params.subType === 'dash' && props.match.params.belowType === 'dw-history'){
    eventT = 14;
  }

  const [SHowLogin, setSHowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showFullMarket, setFullMarket] = useState(false);
  const [tabMenu, setTabMenu] = useState(eventT);
  const [countCricket, setCountCricket] = useState(0);
  const [countSoccer, setCountSoccer] = useState(0);
  const [countTennis, setCountTennis] = useState(0);
  const [isLoggedIn, setLoggedIn] = useState(null);
  const [userid, setId] = useState("");
  const [password, setPassword] = useState("");
  const [refreshhh, setrefreshhh] = useState(false);
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  const [newOpen, setnewOpen] = useState(false);
  const [expoSu, setexpoSu] = useState(false)
  const [refreshMsg, setrefreshMsg] = useState('Loading...')
  const [Tvopen, setTvopen] = useState(true)
  const [openLeftside, setopenLeftside] = useState(false)
  const [openRightside, setopenRightside] = useState(false)
  const [FancyRulespopup, setFancyRulespopup] = useState(false)
  const [msgNumber, setMsgNumber] = useState(0);
  const [betInfo, setbetInfo] = useState({});
  const [stakeInfo, setstakeInfo] = useState({});
  const [isShown, setisShown] = useState(false);
  const [liveStream, setliveStream] = useState(null);
  const [PrivacyPolicy, setPrivacyPolicy] = useState(false);
  const [TermnCo, setTermnCo] = useState(false);
  const [RnR, setRnR] = useState(false);
  const [kyc, setkyc] = useState(false);
  const [Resg, setResg] = useState(false);
  const [Abtus, setAbtus] = useState(false);
  const [SEP, setSEP] = useState(false);
  const [UApolcy, setUApolcy] = useState(false);
  const [updated, setupdated] = useState(false);
  const [casinoWait, setcasinoWait] = useState(false);
  const [transactionState, settransactionState] = useState(false);
  const [transactionCode, settransactionCode] = useState('');
  const [AEBalance, setAEBalance] = useState(0);
  const [GEbalance, setGEbalance] = useState(0);
  const [REBalance, setREBalance] = useState(0);
  const [EZBalance, setEZBalance] = useState(0);
  const [JLBalance, setJLBalance] = useState(0);
  const [loading, setloading] = useState(false);
  // navcasino
  const [navbarcas, setnavbarcas] = useState(false);


  // modal
  // const [casinoModal, setCasinoModal] = useState(false);

  // const apiURLHandler = 'https://liveapi247.live/api8/';
  //

  const navcasinoclick = () => {
    setnavbarcas(!navbarcas)
  }

  const changeLiveStreaming = (val) => {
    setliveStream(val);
    setTvopen(true);
  }

  const NewsClick = () => {
    setnewOpen(!newOpen)
  }

  const updatepropsTransaction = (openProvider) => {
    settransactionCode(openProvider)
    settransactionState(true)

  }

  const handlepolicy = (val1, val2) => {
    if (val1 === 1) {
      setPrivacyPolicy(val2);
    }
    if (val1 === 2) {
      setTermnCo(val2)
    }
    if (val1 === 3) {
      setRnR(val2)
    }
    if (val1 === 4) {
      setkyc(val2)
    }
    if (val1 === 5) {
      setResg(val2)
    }
    if (val1 === 6) {
      setAbtus(val2)
    }
    if (val1 === 7) {
      setSEP(val2)
    }
    if (val1 === 8) {
      setUApolcy(val2)
    }
  }

  const handlerightside = () => {
    setopenRightside(true)
  }

  const handlerightsideclose = () => {
    setopenRightside(false)
  }

  const handleleftside = () => {
    setopenLeftside(true)
  }

  const handleleftsideclose = () => {
    setopenLeftside(false)
  }


  const changeMsgNumber = (val) => {
    setMsgNumber(val);
  }

  const changeBetInfo = (obj) => {
    var obj2 = obj;
    setbetInfo(obj2);
  }

  const changeStakeInfo = (obj) => {
    var obj2 = obj;
    setstakeInfo(obj2);
  }

  useEffect(() => {
    setTabMenu(eventT);

  }, [eventT]);


  // check login

  useEffect(() => {
    if (cookies.get('token') == null) {
      setLoggedIn(false);
      return;
    } else {
      var utoken = cookies.get('token');
      tt = utoken;
      var user = cookies.get('id');
      var password = cookies.get('password');


      setId(user);
      setPassword(password);

      if (user && utoken) {
        setLoggedIn(true);
      }

      // axios.post('https://liveapi247.live/api8/refresh_balance', {
      //     id: user,
      //     token: utoken
      // }).then(async result => {

      //   if (result.status === 210) {
      //     // console.log('refresh successful');
      //     setLoggedIn(true);
      //     setBalance(result.data[0].mainBalance - Math.abs(result.data[0].exposureBalance));
      //     // localStorage.setItem('mainBalance', result.data[0].mainBalance);
      //       setEZBalance(result.data[0].ezugi_credit);
      //       setREBalance(result.data[0].kingmaker_credit);
      //       setJLBalance(result.data[0].jili_credit);
      //       setGEbalance(result.data[0].ge_credit);
      //       setAEBalance(result.data[0].awc_credit);

      //       let getTransactionState = transactionState;
      //       let getTransactionCode = transactionCode;

      //     if (getTransactionState === null || getTransactionState === undefined) {
      //       localStorage.setItem('transactionState', false);
      //       // settransactionState(false)
      //       await getBalance(user, password, 'GE', result.data[0].mainBalance, utoken, result.data[0].ge_credit);

      //     }

      //     if (getTransactionCode === null || getTransactionCode === undefined) {
      //       localStorage.setItem('transactionCode', '');
      //       // settransactionCode('')
      //     }

      //     if (result.data[0].exposureBalance) {
      //         setExposure(Math.abs(result.data[0].exposureBalance));
      //     } else {
      //         setExposure(0);
      //     }
      //   }

      //   if (result.status === 220) {
      //     // console.log('refresh unsucessful');
      //     setLoggedIn(false);
      //   }
      // }).catch(e => {
      //     setIsError(true);
      // });

    }
  }, []);



  const changeState = (obj) => {
    var obj1 = true;
    obj1 = obj;
    setFullMarket(obj1);
    changeTab(0);
  };

  const changeExposure = (obj) => {
    setExposure(obj);
  }

  const changeBalance = (obj) => {
    setBalance(obj);
  }

  const changeTab = (val) => {
    setTabMenu(val);
  }
  const checkShowLogin = (bool) => {
    setSHowLogin(bool);
  }

  const handleLogout = () => {
    cookies.remove('id', { path: '/' });
    cookies.remove('token', { path: '/' });
    setTabMenu(3);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }

  const handleRefreshhh = (t = 1000, msg = 'Loading...', flag = 0) => {
    if(t === false){
      setrefreshhh(false);
      setrefreshMsg('');
    } else {
      if (flag === 1) {
        setrefreshhh(true);
        setrefreshMsg(msg);
      } else if (flag === 2) {
        setrefreshhh(false);
      } else {
        setrefreshhh(true);
        setrefreshMsg(msg)
        setTimeout(() => {
          setrefreshhh(false);
        }, t);
      }
    }
  }

  const setLoadingOverly = (state, msg = 'Loading...')=> {
    setrefreshhh(state);
    setrefreshMsg(msg);
  }

  const ChangeTv = () => {
    setTvopen(!Tvopen)
    TvControl();
  }
  const ChangeSetTv = (state = false) => {
    setTvopen(state)
  }

  const openLogin = () => {
    if (!isLoggedIn) {
      checkShowLogin(true);
      return;
    }
  }

  const hnadlefancyrules = () => {
    setFancyRulespopup(true)
  }

  const closefancyrules = () => {
    setFancyRulespopup(false)
  }

  const TvControl = () => {
    setisShown(true);
    setTimeout(() => {
      setisShown(false)
    }, 2700);
  }

  const [refCode, setRefCode] = useState('');

  useEffect(() => {
    const searchParms = window.location.search;
    if (searchParms.includes('refcode')) {
      const refCode = queryString.parse(searchParms)?.refcode;
      setRefCode(refCode);
      setShowRegister(true);
    }
  }, []);

  // refresh balance
  const refreshBalanceApiAction = useMutation({
    mutationFn: refreshBalanceApiRq,
    onMutate: () => {},
    onSuccess: rsp => {
      queryClient.setQueryData([RQ_KEY.STORE_USER_DATA], rsp);
    },
    onError: () => null
  });

  const token = cookies.get('token');
  const clientId = cookies.get('id');

  const handleBalanceRefresh = () => {
    refreshBalanceApiAction.mutate({ id: clientId, token: token });
  }


  // news
  let getNewsData = getRqData(RQ_KEY.STORE_NEWS_DATA);

  return (
      <React.Fragment>
        <LoadingOverlay
            show={loading || globalLoading}
        />
        {SHowLogin && <Loginmobile checkShowLogin={checkShowLogin} handlepolicy={handlepolicy} />}
        {showRegister && <RegisterMobile refCode={refCode} setShowRegister={setShowRegister}  />}
        {(!showRegister && !SHowLogin )&& <Header Tvopen={Tvopen} setloading={setloading} loading={loading} AEBalance={AEBalance} setAEBalance={setAEBalance} setEZBalance={setEZBalance} setREBalance={setREBalance} setJLBalance={setJLBalance} setGEbalance={setGEbalance} EZBalance={EZBalance} REBalance={REBalance} JLBalance={JLBalance} GEbalance={GEbalance} updated={updated} setupdated={setupdated} handleRefreshhh={handleRefreshhh} liveStream={liveStream} stakeInfo={stakeInfo} betInfo={betInfo} msgNumber={msgNumber} changeMsgNumber={changeMsgNumber} refreshMsg={refreshMsg} ChangeTv={ChangeTv} changeExposure={changeExposure} changeBalance={changeBalance} refreshhh={refreshhh} tabMenu={tabMenu} userid={userid} utoken={tt} exposure={exposure} balance={balance} openLeftside={openLeftside} openRightside={openRightside} handlerightside={handlerightside} handlerightsideclose={handlerightsideclose} handleleftsideclose={handleleftsideclose} handleleftside={handleleftside} isLoggedIn={isLoggedIn} setLoggedIn={setLoggedIn} checkShowLogin={checkShowLogin} handleLogout={handleLogout} setShowRegister={setShowRegister} />}
        {(!SHowLogin && isLoggedIn === true && getNewsData && getNewsData.data && getNewsData.data.length > 0) && <ANnouncement NewsClick={NewsClick} userid={userid} utoken={tt} />}
        {/* {!SHowLogin && Tvopen === true && tabMenu ===0 && isLoggedIn === true && liveStream && liveStream != '' &&<TVStremaing liveStream = {liveStream} isShown={isShown} TvControl={TvControl} ChangeSetTv={ChangeSetTv} Tvopen={Tvopen}/>} */}

        {(!showRegister && !SHowLogin) && (tabMenu === 1 || tabMenu === 3 || tabMenu === 12 || tabMenu === 13 || tabMenu === 14) && isLoggedIn === true && <TopHeader isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} mt={(!getNewsData || !getNewsData?.data || getNewsData?.data?.length === 0) ? '14.6667vw' : '21.6667vw'} tabMenu={tabMenu} />}
     {(!showRegister && !SHowLogin) && (tabMenu === 1 || tabMenu === 3) &&   <Topbanner/>}
        {(!showRegister && !SHowLogin) && (tabMenu === 1 || tabMenu === 3) &&  <Carousel />}




        {/* {!SHowLogin && isLoggedIn === true && (tabMenu === 3 || tabMenu === 6 || tabMenu === 7 || tabMenu === 9 || tabMenu === 10 || tabMenu === 11 || tabMenu === 12 || tabMenu === 13 || tabMenu === 14) && <CasinoCarousel/>} */}
        {(!showRegister && !SHowLogin) && (tabMenu === 1 || (tabMenu === 5 && !isLoggedIn)) && <Highlights handlepolicy={handlepolicy} isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} handlepolicy={handlepolicy} countTennis={countTennis} countSoccer={countSoccer} countCricket={countCricket} showFullMarket={showFullMarket} changeState={changeState} />}


        {(!showRegister && !SHowLogin) && (tabMenu === 3) && <Home openLogin={openLogin} AEBalance={AEBalance} EZBalance={EZBalance} REBalance={REBalance} GEbalance={GEbalance} JLBalance={JLBalance} casinoWait={casinoWait} isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} />}
        {/* {!SHowLogin && (tabMenu === 11) && <CasinoList isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} />} */}
        {!navbarcas === false && <Navcasino isLoggedIn={isLoggedIn} navbarcas={navbarcas} navcasinoclick={navcasinoclick} />}
        {(!showRegister && !SHowLogin) && tabMenu === 0 && <Newfullmarket liveStream={liveStream} isShown={isShown} TvControl={TvControl} ChangeSetTv={ChangeSetTv}  Tvopen={Tvopen} changeLiveStreaming={changeLiveStreaming} isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} changeStakeInfo={changeStakeInfo} changeBetInfo={changeBetInfo} changeMsgNumber={changeMsgNumber} userid={userid} utoken={tt} handleRefreshhh={handleRefreshhh} setLoadingOverly={setLoadingOverly} hnadlefancyrules={hnadlefancyrules} />}

        {(!showRegister && !SHowLogin) && tabMenu === 9 && <WinnerMarket />}

        {(!showRegister && !SHowLogin) && tabMenu === 2 && <InPlay isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} changeState={changeState} userid={userid} utoken={tt} handleRefreshhh={handleRefreshhh} />}

        {(!showRegister && !SHowLogin) && tabMenu === 4 && <Multimarket isLoggedIn={isLoggedIn} checkShowLogin={checkShowLogin} changeState={changeState} userid={userid} utoken={tt} handleRefreshhh={handleRefreshhh} />}

        {(!SHowLogin && !showRegister) && <Footer navbarcas={navbarcas} navcasinoclick={navcasinoclick} isLoggedIn={isLoggedIn} changeTab={changeTab} checkShowLogin={checkShowLogin} tabMenu={tabMenu} />}
        {(!showRegister && !SHowLogin) && tabMenu === 5 && isLoggedIn === true && <Account userid={userid} handleLogout={handleLogout} />}

        {(!showRegister && !SHowLogin) && tabMenu === 12 && isLoggedIn === true && <Deposit />}
        {(!showRegister && !SHowLogin) && tabMenu === 13 && isLoggedIn === true && <Withdraw handleBalanceRefresh={handleBalanceRefresh} />}
        {(!showRegister && !SHowLogin) && tabMenu === 14 && isLoggedIn === true && <DwHistory />}


        {FancyRulespopup === true && <FancyRules closefancyrules={closefancyrules} />}
        {PrivacyPolicy === true && <FooterPolicy handlepolicy={handlepolicy} />}
        {TermnCo === true && <FooterGtc handlepolicy={handlepolicy} />}
        {RnR === true && <FooterRnr handlepolicy={handlepolicy} />}
        {kyc === true && <Footerkyc handlepolicy={handlepolicy} />}
        {Resg === true && <FooterResGaming handlepolicy={handlepolicy} />}
        {Abtus === true && <FooterAboutus handlepolicy={handlepolicy} />}
        {SEP === true && <FooterSepolicy handlepolicy={handlepolicy} />}
        {UApolcy === true && <FooterUpolicy handlepolicy={handlepolicy} />}


        {isLoggedIn && (
          <Link
              to="/d/dash/deposit"
              className="deposit-money-btn"
          >
            <img src={moneyIcon} />    
          </Link>
        )}      
          
        
      </React.Fragment>
  )
}
